module.exports = __webpack_public_path__ + "media/fonts/Roboto-Regular-03523cf578d69fa923226ff457b92d90.ttf";